"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iniciarFirma = exports.guardarDatosNotariales = exports.getPhoneFusion = exports.finalizarFirma = exports.consultarDatosNotariales = exports.consultaParque = exports.consultaOfertaM = exports.consultaDatosLineaM = exports.consultaDatosLineaF = exports.consultaDatosClienteM = exports.consultaDatosClienteG = exports.consultaDatosBancarios = exports.autenticarSealSign = void 0;

var _legadoApi = require("../../../apis/legadoApi");

var _clientNormalizer = require("../../../normalizers/legado/clientNormalizer");

var _gerenciatdAdabyronUtils = require("@bit/gerenciatd.adabyron-utils.monitoring");

var _gerenciatdAdabyronUtils2 = require("@bit/gerenciatd.adabyron-utils.error");

var _gerenciatdUtils = _interopRequireWildcard(require("@bit/gerenciatd.utils.sonda"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

// } from '../utils/error';

/* global MOCK_ALLOWED:true */
var NODE_ENV = process.env.NODE_ENV;

var castCertiEntry = function castCertiEntry(entry) {
  if (sessionStorage && sessionStorage.getItem('datosUsuarioEntrada') && sessionStorage.getItem('datosUsuarioEntrada') !== '') {
    entry.datosUsuarioEntrada = JSON.parse(sessionStorage.getItem('datosUsuarioEntrada'));
  }

  return entry;
};

var consultaClienteGSuccess = function consultaClienteGSuccess(infoSuccess) {
  var sonda = infoSuccess.sonda,
      responseObj = infoSuccess.responseObj;
  var responseObjNormalize = (0, _clientNormalizer.normalizeClientGInfo)(responseObj);
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.OK);
  return responseObjNormalize;
};

var consultaClienteGError = function consultaClienteGError(infoError) {
  var sonda = infoError.sonda,
      _infoError$req = infoError.req,
      req = _infoError$req === void 0 ? {} : _infoError$req,
      errorData = infoError.errorData;
  var newReq = {};
  var newResponse = req.response;

  if (typeof req.response === 'string') {
    newResponse = JSON.parse(req.response);
  }

  if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
    newResponse = req.response;
  }

  newReq.status = newResponse.codError + ' - ' + newResponse.tipoError;
  newReq.statusText = newResponse.descError;
  var objError = (0, _gerenciatdAdabyronUtils2.normalizeObjError)(newReq);
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.ERROR, objError); // si el normalizador no consigue meter un response

  if (objError && !objError.response) {
    objError.response = {
      error: errorData || true
    };
  }

  return objError;
};

var consultaDatosClienteG = function consultaDatosClienteG(infoNavegacion) {
  var contextSonda = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var idFront = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'webM';
  var context = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'F';
  var idRequest = (0, _legadoApi.getUUID)(idFront);
  var sonda = new _gerenciatdUtils["default"]('CLIENT.CONSULTA_DATOS_CLIENTE_G', _gerenciatdAdabyronUtils.processName, contextSonda, idRequest);
  var sondaM = new _gerenciatdUtils["default"]('CLIENT.CONSULTA_DATOS_CLIENTE_G_contextM', _gerenciatdAdabyronUtils.processName, contextSonda, idRequest);

  try {
    var URL_API = context === 'M' ? "".concat(_legadoApi.API.CLIENT.CONSULTA_DATOS_CLIENTE_G_FIRMA_SOLO_MOVIL, "?").concat(idRequest) : "".concat(_legadoApi.API.CLIENT.CONSULTA_DATOS_CLIENTE_G, "?").concat(idRequest);
    var input = {
      codFrontal: idFront,
      flagConsultaExtendida: true,
      flagActualizar: false,
      contexto: context
    };

    if (NODE_ENV && NODE_ENV !== 'test') {
      if (sessionStorage && sessionStorage.getItem('firma') === 'si' && (sessionStorage.getItem('devEnvironment') === 'CERTI' || sessionStorage.getItem('devEnvironment') === 'CERTI_PRE')) {
        input = castCertiEntry(input);
      }

      if (typeof MOCK_ALLOWED !== 'undefined' && MOCK_ALLOWED) {
        if (sessionStorage && sessionStorage.getItem('consultaDatosClienteG') === 'mock') {
          URL_API = _legadoApi.API.CLIENT.CONSULTA_DATOS_CLIENTE_G_MOCK;
        } else if (sessionStorage && sessionStorage.getItem('firma') === 'si') {
          URL_API = _legadoApi.API.CLIENT.CONSULTA_DATOS_CLIENTE_G_FIRMA; // Por error en servicio de sistemas

          input.flagActualizar = true;
        }
      }
    } // Return a new promise.


    return new Promise(function (resolve, reject) {
      // Do the usual XHR stuff
      var req = new XMLHttpRequest();
      sonda.startWS();
      req.open('POST', URL_API);

      req.onload = function () {
        if (req.status === 200) {
          var responseObj = null;

          if (typeof req.response === 'string') {
            responseObj = JSON.parse(req.response);
          }

          if (_typeof(req.response) === 'object') {
            responseObj = req.response;
          }

          if (responseObj.resultado === 1) {
            var objError = consultaClienteGError({
              sonda: sonda,
              req: req
            });
            reject(objError);
          } else {
            var responseObjSuccess = consultaClienteGSuccess({
              sonda: sonda,
              responseObj: responseObj
            });
            resolve(responseObjSuccess);
          } // Si hay un error en el servicio al consultar con contexto F o hay un error en la estructura datosClienteG,
          // relanzo la petición con contexto M
          // eslint-disable-next-line max-len


          if (context === 'F' && (responseObj && responseObj.resultado === 1 || responseObj && responseObj.resultado === 0 && typeof responseObj.datosClienteG.codError !== 'undefined')) {
            var myEventContextM = (0, _gerenciatdAdabyronUtils.createEvent)('CLIENT.CONSULTA_DATOS_CLIENTE_G_contextM');
            var idRequestContextM = (0, _legadoApi.getUUID)(idFront);
            var reqContextM = new XMLHttpRequest();
            (0, _gerenciatdAdabyronUtils.sendLoadingService)(_gerenciatdAdabyronUtils.processName, myEventContextM, idRequestContextM);
            reqContextM.open('POST', URL_API);

            reqContextM.onload = function () {
              // This is called even on 404 etc
              // so check the status
              if (reqContextM.status === 200) {
                // Resolve the promise with the response text
                var _responseObj = JSON.parse(reqContextM.response);

                if (_responseObj && _responseObj.resultado === 0) {
                  if (typeof _responseObj.datosClienteG.codError === 'undefined') {
                    resolve((0, _clientNormalizer.normalizeClientGInfo)(_responseObj));

                    var _responseObjSuccess = consultaClienteGSuccess({
                      sondaM: sondaM,
                      responseObj: _responseObj
                    });

                    resolve(_responseObjSuccess);
                  } else {
                    var _objError = consultaClienteGError({
                      sonda: sonda,
                      req: req
                    });

                    _objError.URL_API = URL_API;
                    _objError.input = JSON.stringify(input);
                    _objError.infoNavegacion = infoNavegacion;
                    reject(_objError);
                  }
                } else {
                  var _objError2 = consultaClienteGError({
                    sonda: sonda,
                    req: req
                  });

                  _objError2.URL_API = URL_API;
                  _objError2.input = JSON.stringify(input);
                  _objError2.infoNavegacion = infoNavegacion;
                  reject(_objError2);
                }
              } else {
                var _objError3 = consultaClienteGError({
                  sonda: sonda,
                  req: req
                });

                _objError3.URL_API = URL_API;
                _objError3.input = JSON.stringify(input);
                _objError3.infoNavegacion = infoNavegacion;
                reject(_objError3);
              }
            }; // Handle network errors


            reqContextM.onerror = function () {
              var objError = consultaClienteGError({
                sonda: sonda,
                req: req
              });
              objError.URL_API = URL_API;
              objError.input = JSON.stringify(input);
              objError.infoNavegacion = infoNavegacion;
              objError.status = reqContextM.status;
              objError.statusText = reqContextM.statusText;
              objError.response = reqContextM.response;
              reject(objError);
            };

            reqContextM.setRequestHeader('Accept', 'application/json');
            reqContextM.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            input.contexto = 'M'; // eslint-disable-next-line max-len
            // const data = `ENTRADA=%7B%22codFrontal%22%3A%22${input.codFrontal}%22%2C%22flagConsultaExtendida%22%3Atrue%2C%22flagActualizar%22%3A${input.flagActualizar}%2C%22contexto%22%3A%22${input.contexto}%22%7D`;

            var _data = 'ENTRADA=' + JSON.stringify(input);

            reqContextM.send(_data);
          }
        } else {
          var _objError4 = consultaClienteGError({
            sonda: sonda,
            req: req
          });

          _objError4.URL_API = URL_API;
          _objError4.input = JSON.stringify(input);
          _objError4.infoNavegacion = infoNavegacion;
          reject(_objError4);
        }
      }; // Handle network errors


      req.onerror = function () {
        var objError = consultaClienteGError({
          sonda: sonda,
          req: req
        });
        objError.URL_API = URL_API;
        objError.input = JSON.stringify(input);
        objError.infoNavegacion = infoNavegacion;
        objError.status = req.status;
        objError.statusText = req.statusText;
        objError.response = req.response;
        reject(objError);
      };

      req.setRequestHeader('Accept', 'application/json');
      req.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded'); // eslint-disable-next-line max-len
      // const data = `ENTRADA=%7B%22codFrontal%22%3A%22${input.codFrontal}%22%2C%22flagConsultaExtendida%22%3Atrue%2C%22flagActualizar%22%3A${input.flagActualizar}%2C%22contexto%22%3A%22${input.contexto}%22%7D`;

      var data = 'ENTRADA=' + JSON.stringify(input);
      req.send(data);
    });
  } catch (errorCatch) {
    sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.JS_ERROR);
    return null;
  }
};

exports.consultaDatosClienteG = consultaDatosClienteG;

var getConsultaDatosClienteMError = function getConsultaDatosClienteMError(infoError) {
  var sonda = infoError.sonda,
      _infoError$req2 = infoError.req,
      req = _infoError$req2 === void 0 ? {} : _infoError$req2,
      errorData = infoError.errorData;
  var newReq = {};
  var newResponse = req.response;

  if (typeof req.response === 'string') {
    newResponse = JSON.parse(req.response);
  }

  if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
    newResponse = req.response;
  }

  newReq.status = newResponse.codError + ' - ' + newResponse.tipoError;
  newReq.statusText = newResponse.descError;
  var objError = (0, _gerenciatdAdabyronUtils2.normalizeObjError)(newReq);
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.ERROR, objError); // si el normalizador no consigue meter un response

  if (objError && !objError.response) {
    objError.response = {
      error: errorData || true
    };
  }

  return objError;
};

var getConsultaDatosClienteMSuccess = function getConsultaDatosClienteMSuccess(infoSuccess) {
  var sonda = infoSuccess.sonda,
      responseObj = infoSuccess.responseObj;
  var responseObjNormalize = (0, _clientNormalizer.normalizeClientMInfo)(responseObj);
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.OK);
  return responseObjNormalize;
};

var consultaDatosClienteM = function consultaDatosClienteM() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var idFront = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'webM';
  var idRequest = (0, _legadoApi.getUUID)(idFront);
  var sonda = new _gerenciatdUtils["default"]('CLIENT.CONSULTA_DATOS_CLIENTE_M', _gerenciatdAdabyronUtils.processName, context, idRequest);

  try {
    var URL_API = "".concat(_legadoApi.API.CLIENT.CONSULTA_DATOS_CLIENTE_M, "?").concat(idRequest);
    var input = {
      codFrontal: idFront
    };

    if (NODE_ENV && NODE_ENV !== 'test') {
      if (sessionStorage && sessionStorage.getItem('firma') === 'si' && (sessionStorage.getItem('devEnvironment') === 'CERTI' || sessionStorage.getItem('devEnvironment') === 'CERTI_PRE')) {
        input = castCertiEntry(input);
      }

      if (typeof MOCK_ALLOWED !== 'undefined' && MOCK_ALLOWED) {
        if (sessionStorage && sessionStorage.getItem('consultaDatosClienteM') === 'mock') {
          URL_API = _legadoApi.API.CLIENT.CONSULTA_DATOS_CLIENTE_M_MOCK;
        } else if (sessionStorage && sessionStorage.getItem('firma') === 'si') {
          URL_API = _legadoApi.API.CLIENT.CONSULTA_DATOS_CLIENTE_M_FIRMA;
        }
      }
    }

    return new Promise(function (resolve, reject) {
      var req = new XMLHttpRequest();
      sonda.startWS();
      req.open('POST', URL_API);

      req.onload = function () {
        if (req.status === 200) {
          var responseObj = null;

          if (typeof req.response === 'string') {
            responseObj = JSON.parse(req.response);
          }

          if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
            responseObj = req.response;
          }

          if (responseObj.resultado === 1) {
            var objError = getConsultaDatosClienteMError({
              sonda: sonda,
              req: req
            });
            reject(objError);
          } else {
            var responseObjSuccess = getConsultaDatosClienteMSuccess({
              sonda: sonda,
              responseObj: responseObj
            });
            resolve(responseObjSuccess);
          }
        } else {
          var _objError5 = getConsultaDatosClienteMError({
            sonda: sonda,
            req: req
          });

          reject(_objError5);
        }
      };

      req.onerror = function () {
        var objError = getConsultaDatosClienteMError({
          sonda: sonda,
          req: req
        });
        reject(objError);
      }; // Make the request


      req.setRequestHeader('Accept', 'application/json');
      req.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      var data = 'ENTRADA=' + JSON.stringify(input);
      req.send(data);
    });
  } catch (errorCatch) {
    sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.JS_ERROR);
    return null;
  }
};

exports.consultaDatosClienteM = consultaDatosClienteM;

var getConsultaDatosLineaMError = function getConsultaDatosLineaMError(infoError) {
  var sonda = infoError.sonda,
      _infoError$req3 = infoError.req,
      req = _infoError$req3 === void 0 ? {} : _infoError$req3,
      errorData = infoError.errorData;
  var newReq = {};
  var newResponse = req.response;

  if (typeof req.response === 'string') {
    newResponse = JSON.parse(req.response);
  }

  if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
    newResponse = req.response;
  }

  newReq.status = newResponse.codError + ' - ' + newResponse.tipoError;
  newReq.statusText = newResponse.descError;
  var objError = (0, _gerenciatdAdabyronUtils2.normalizeObjError)(newReq);
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.ERROR, objError); // si el normalizador no consigue meter un response

  if (objError && !objError.response) {
    objError.response = {
      error: errorData || true
    };
  }

  return objError;
};

var getConsultaDatosLineaMSuccess = function getConsultaDatosLineaMSuccess(infoSuccess) {
  var sonda = infoSuccess.sonda,
      responseObj = infoSuccess.responseObj;
  var responseObjNormalize = responseObj;
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.OK);
  return responseObjNormalize;
};

var consultaDatosLineaM = function consultaDatosLineaM(data) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var idFront = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'webM';
  var idRequest = (0, _legadoApi.getUUID)(idFront);
  var sonda = new _gerenciatdUtils["default"]('CLIENT.CONSULTA_DATOS_LINEA_M', _gerenciatdAdabyronUtils.processName, context, idRequest);

  try {
    var URL_API = "".concat(_legadoApi.API.CLIENT.CONSULTA_DATOS_LINEA_M, "?").concat(idRequest);
    var input = {
      codFrontal: idFront
    };

    if (NODE_ENV && NODE_ENV !== 'test') {
      if (sessionStorage && sessionStorage.getItem('firma') === 'si' && (sessionStorage.getItem('devEnvironment') === 'CERTI' || sessionStorage.getItem('devEnvironment') === 'CERTI_PRE')) {
        input = castCertiEntry(input);
      }

      if (typeof MOCK_ALLOWED !== 'undefined' && MOCK_ALLOWED) {
        if (sessionStorage && sessionStorage.getItem('consultaDatosLineaM') === 'mock') {
          URL_API = _legadoApi.API.CLIENT.CONSULTA_DATOS_LINEA_M_MOCK;
        } else if (sessionStorage && sessionStorage.getItem('firma') === 'si') {
          URL_API = _legadoApi.API.CLIENT.CONSULTA_DATOS_LINEA_M_FIRMA;
        }
      }
    }

    return new Promise(function (resolve, reject) {
      var req = new XMLHttpRequest();
      sonda.startWS();
      req.open('POST', URL_API);

      req.onload = function () {
        if (req.status === 200) {
          var responseObj = null;

          if (typeof req.response === 'string') {
            responseObj = JSON.parse(req.response);
          }

          if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
            responseObj = req.response;
          }

          if (responseObj.resultado === 1) {
            var objError = getConsultaDatosLineaMError({
              sonda: sonda,
              req: req
            });
            reject(objError);
          } else {
            var responseObjSuccess = getConsultaDatosLineaMSuccess({
              sonda: sonda,
              responseObj: responseObj
            });
            resolve(responseObjSuccess);
          }
        } else {
          var _objError6 = getConsultaDatosLineaMError({
            sonda: sonda,
            req: req
          });

          reject(_objError6);
        }
      };

      req.onerror = function () {
        var objError = getConsultaDatosLineaMError({
          sonda: sonda,
          req: req
        });
        reject(objError);
      }; // Make the request


      req.setRequestHeader('Accept', 'application/json');
      req.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      var data = 'ENTRADA=' + JSON.stringify(input);
      req.send(data);
    });
  } catch (errorCatch) {
    sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.JS_ERROR);
    return null;
  }
};

exports.consultaDatosLineaM = consultaDatosLineaM;

var getConsultaDatosBancariosError = function getConsultaDatosBancariosError(infoError) {
  var sonda = infoError.sonda,
      _infoError$req4 = infoError.req,
      req = _infoError$req4 === void 0 ? {} : _infoError$req4,
      errorData = infoError.errorData;
  var newReq = {};
  var newResponse = req.response;

  if (typeof req.response === 'string') {
    newResponse = JSON.parse(req.response);
  }

  if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
    newResponse = req.response;
  }

  newReq.status = newResponse.codError + ' - ' + newResponse.tipoError;
  newReq.statusText = newResponse.descError;
  var objError = (0, _gerenciatdAdabyronUtils2.normalizeObjError)(newReq);
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.ERROR, objError); // si el normalizador no consigue meter un response

  if (objError && !objError.response) {
    objError.response = {
      error: errorData || true
    };
  }

  return objError;
};

var getConsultaDatosBancariosSuccess = function getConsultaDatosBancariosSuccess(infoSuccess) {
  var sonda = infoSuccess.sonda,
      responseObj = infoSuccess.responseObj;
  var responseObjNormalize = responseObj;
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.OK);
  return responseObjNormalize;
};

var consultaDatosBancarios = function consultaDatosBancarios(data) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var idFront = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'webM';
  var idRequest = (0, _legadoApi.getUUID)(idFront);
  var sonda = new _gerenciatdUtils["default"]('CLIENT.CONSULTA_DATOS_BANCARIOS', _gerenciatdAdabyronUtils.processName, context, idRequest);

  try {
    var URL_API = "".concat(_legadoApi.API.CLIENT.CONSULTA_DATOS_BANCARIOS, "?").concat(idRequest);
    var input = {
      codFrontal: idFront,
      flagActualizar: false,
      listaConsultasBancarias: data
    };

    if (NODE_ENV && NODE_ENV !== 'test') {
      if (sessionStorage && sessionStorage.getItem('firma') === 'si' && (sessionStorage.getItem('devEnvironment') === 'CERTI' || sessionStorage.getItem('devEnvironment') === 'CERTI_PRE')) {
        input = castCertiEntry(input);
      }

      if (typeof MOCK_ALLOWED !== 'undefined' && MOCK_ALLOWED) {
        if (sessionStorage && sessionStorage.getItem('consultaDatosBancarios') === 'mock') {
          URL_API = _legadoApi.API.CLIENT.CONSULTA_DATOS_BANCARIOS_MOCK;
        } else if (sessionStorage && sessionStorage.getItem('firma') === 'si') {
          URL_API = _legadoApi.API.CLIENT.CONSULTA_DATOS_BANCARIOS_FIRMA;
        }
      }
    }

    return new Promise(function (resolve, reject) {
      var req = new XMLHttpRequest();
      sonda.startWS();
      req.open('POST', URL_API);

      req.onload = function () {
        if (req.status === 200) {
          var responseObj = null;

          if (typeof req.response === 'string') {
            responseObj = JSON.parse(req.response);
          }

          if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
            responseObj = req.response;
          }

          if (responseObj.resultado === 1) {
            var objError = getConsultaDatosBancariosError({
              sonda: sonda,
              req: req
            });
            reject(objError);
          } else if (responseObj.resultado === 0 && responseObj.listaDatosBancarios.some(function (x) {
            return x.resultado === 1;
          })) {
            var _objError7 = getConsultaDatosBancariosError({
              sonda: sonda,
              req: req
            });

            reject(_objError7);
          } else {
            var responseObjSuccess = getConsultaDatosBancariosSuccess({
              sonda: sonda,
              responseObj: responseObj
            });
            resolve(responseObjSuccess);
          }
        } else {
          var _objError8 = getConsultaDatosBancariosError({
            sonda: sonda,
            req: req
          });

          reject(_objError8);
        }
      };

      req.onerror = function () {
        var objError = getConsultaDatosBancariosError({
          sonda: sonda,
          req: req
        });
        reject(objError);
      }; // Make the request


      req.setRequestHeader('Accept', 'application/json');
      req.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      var data = 'ENTRADA=' + JSON.stringify(input);
      req.send(data);
    });
  } catch (errorCatch) {
    sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.JS_ERROR);
    return null;
  }
};

exports.consultaDatosBancarios = consultaDatosBancarios;

var getConsultaDatosLineaFError = function getConsultaDatosLineaFError(infoError) {
  var sonda = infoError.sonda,
      _infoError$req5 = infoError.req,
      req = _infoError$req5 === void 0 ? {} : _infoError$req5,
      errorData = infoError.errorData;
  var newReq = {};
  var newResponse = req.response;

  if (typeof req.response === 'string') {
    newResponse = JSON.parse(req.response);
  }

  if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
    newResponse = req.response;
  }

  newReq.status = newResponse.codError + ' - ' + newResponse.tipoError;
  newReq.statusText = newResponse.descError;
  var objError = (0, _gerenciatdAdabyronUtils2.normalizeObjError)(newReq);
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.ERROR, objError); // si el normalizador no consigue meter un response

  if (objError && !objError.response) {
    objError.response = {
      error: errorData || true
    };
  }

  return objError;
};

var getConsultaDatosLineaFSuccess = function getConsultaDatosLineaFSuccess(infoSuccess) {
  var sonda = infoSuccess.sonda,
      responseObj = infoSuccess.responseObj;
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.OK);
  return responseObj;
};

var consultaDatosLineaF = function consultaDatosLineaF() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var numsComercialConsultados = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['01', '09', '18'];
  var idFront = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'webM';
  var idRequest = (0, _legadoApi.getUUID)(idFront);
  var sonda = new _gerenciatdUtils["default"]('CLIENT.CONSULTA_DATOS_LINEA_F', _gerenciatdAdabyronUtils.processName, context, idRequest);

  try {
    var URL_API = "".concat(_legadoApi.API.CLIENT.CONSULTA_DATOS_LINEA_F, "?").concat(idRequest);
    var input = {
      codFrontal: idFront,
      tiposNumsComercialConsultados: numsComercialConsultados,
      flgDetalle: true
    };

    if (NODE_ENV && NODE_ENV !== 'test') {
      if (sessionStorage && sessionStorage.getItem('firma') === 'si' && (sessionStorage.getItem('devEnvironment') === 'CERTI' || sessionStorage.getItem('devEnvironment') === 'CERTI_PRE')) {
        input = castCertiEntry(input);
      }

      if (typeof MOCK_ALLOWED !== 'undefined' && MOCK_ALLOWED) {
        if (sessionStorage && sessionStorage.getItem('consultaDatosLineaF') === 'mock') {
          URL_API = _legadoApi.API.CLIENT.CONSULTA_DATOS_LINEA_F_MOCK;
        } else if (sessionStorage && sessionStorage.getItem('firma') === 'si') {
          URL_API = _legadoApi.API.CLIENT.CONSULTA_DATOS_LINEA_F_FIRMA;
        }
      }
    }

    return new Promise(function (resolve, reject) {
      var req = new XMLHttpRequest();
      sonda.startWS();
      req.open('POST', URL_API);

      req.onload = function () {
        if (req.status === 200) {
          var responseObj = null;

          if (typeof req.response === 'string') {
            responseObj = JSON.parse(req.response);
          }

          if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
            responseObj = req.response;
          }

          if (responseObj.resultado === 1) {
            var objError = getConsultaDatosLineaFError({
              sonda: sonda,
              req: req
            });
            reject(objError);
          } else {
            var responseObjSuccess = getConsultaDatosLineaFSuccess({
              sonda: sonda,
              responseObj: responseObj
            });
            resolve(responseObjSuccess);
          }
        } else {
          var _objError9 = getConsultaDatosLineaFError({
            sonda: sonda,
            req: req
          });

          reject(_objError9);
        }
      };

      req.onerror = function () {
        var objError = getConsultaDatosLineaFError({
          sonda: sonda,
          req: req
        });
        reject(objError);
      }; // Make the request


      req.setRequestHeader('Accept', 'application/json');
      req.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      var data = 'ENTRADA=' + JSON.stringify(input);
      req.send(data);
    });
  } catch (errorCatch) {
    sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.JS_ERROR);
    return null;
  }
};

exports.consultaDatosLineaF = consultaDatosLineaF;

var getPhoneFusion = function getPhoneFusion() {
  var idFront = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'webM';
  var myEvent = (0, _gerenciatdAdabyronUtils.createEvent)('CLIENT.GET_PHONE_FUSION');

  try {
    var idRequest = (0, _legadoApi.getUUID)(idFront);
    var URL_API = "".concat(_legadoApi.API.CLIENT.CONSULTA_DATOS_LINEAS_M, "?").concat(idRequest);

    if (NODE_ENV && NODE_ENV !== 'test') {
      if (typeof MOCK_ALLOWED !== 'undefined' && MOCK_ALLOWED) {
        if (sessionStorage && sessionStorage.getItem('consultaDatosLineasM') === 'mock') {
          URL_API = _legadoApi.API.CLIENT.CONSULTA_DATOS_LINEAS_M_MOCK;
        } else if (sessionStorage && sessionStorage.getItem('firma') === 'si') {
          URL_API = _legadoApi.API.CLIENT.CONSULTA_DATOS_LINEAS_M_FIRMA;
        }
      }
    }

    var input = {
      codFrontal: idFront
    }; // Return a new promise.

    return new Promise(function (resolve, reject) {
      // Do the usual XHR stuff
      var req = new XMLHttpRequest();
      (0, _gerenciatdAdabyronUtils.sendLoadingService)(_gerenciatdAdabyronUtils.processName, myEvent, idRequest);
      req.open('POST', URL_API);

      req.onload = function () {
        // This is called even on 404 etc
        // so check the status
        if (req.status === 200) {
          var responseObj = null;

          if (typeof req.response === 'string') {
            responseObj = JSON.parse(req.response);
          }

          if (_typeof(req.response) === 'object') {
            responseObj = req.response;
          }

          if (responseObj && responseObj.resultado === 0) {
            (0, _gerenciatdAdabyronUtils.sendLoadedService)(_gerenciatdAdabyronUtils.processName, myEvent, _gerenciatdAdabyronUtils.finishStates.FINISHED_OK, '', idRequest); // eslint-disable-next-line consistent-return

            var phoneFusion = null;
            responseObj.datosLineasAbono.forEach(function (elem) {
              if (elem.tip_fusion === '00000') {
                phoneFusion = elem.fijo_fusion;
              }
            });
            resolve(phoneFusion);
          } else {
            var newReq = {};
            var newResponse = req.response;

            if (typeof req.response === 'string') {
              newResponse = JSON.parse(req.response);
            }

            if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
              newResponse = req.response;
            }

            newReq.status = newResponse.codError + ' - ' + newResponse.tipoError;
            newReq.statusText = newResponse.descError;
            var objError = (0, _gerenciatdAdabyronUtils2.normalizeObjError)(newReq);
            objError.URL_API = URL_API;
            objError.input = JSON.stringify(input); // eslint-disable-next-line max-len

            (0, _gerenciatdAdabyronUtils.sendLoadedService)(_gerenciatdAdabyronUtils.processName, myEvent, _gerenciatdAdabyronUtils.finishStates.FINISHED_KO, objError, idRequest);

            if (responseObj && responseObj.resultado === 1 && (responseObj.tipoError === 'TXD' && responseObj.codError === 'PT229' || responseObj.tipoError === 'RDL' && responseObj.codError === 'PT225')) {
              // Client without mobile lines, so there is no phoneFusion
              resolve(null);
            } else {
              reject(objError);
            }
          }
        } else {
          // Otherwise reject with the status text
          // which will hopefully be a meaningful error
          var _newReq = {};
          var _newResponse = req.response;

          if (typeof req.response === 'string') {
            _newResponse = JSON.parse(req.response);
          }

          if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
            _newResponse = req.response;
          }

          _newReq.status = _newResponse.codError + ' - ' + _newResponse.tipoError;
          _newReq.statusText = _newResponse.descError;

          var _objError10 = (0, _gerenciatdAdabyronUtils2.normalizeObjError)(_newReq);

          _objError10.URL_API = URL_API;
          _objError10.input = JSON.stringify(input);
          (0, _gerenciatdAdabyronUtils.sendLoadedService)(_gerenciatdAdabyronUtils.processName, myEvent, _gerenciatdAdabyronUtils.finishStates.FINISHED_KO, _objError10, idRequest);
          reject(_objError10);
        }
      }; // Handle network errors


      req.onerror = function () {
        // let objError = normalizeObjErrorNetworkError();
        var objError = {
          status: req.status,
          statusText: req.statusText,
          response: req.response
        };
        objError.URL_API = URL_API;
        objError.input = JSON.stringify(input);
        (0, _gerenciatdAdabyronUtils.sendLoadedService)(_gerenciatdAdabyronUtils.processName, myEvent, _gerenciatdAdabyronUtils.finishStates.FINISHED_KO, objError, idRequest);
        reject(objError);
      };

      req.setRequestHeader('Accept', 'application/json');
      req.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      var data = 'ENTRADA=' + JSON.stringify(input);
      req.send(data);
    });
  } catch (errorCatch) {
    var objError = (0, _gerenciatdAdabyronUtils2.normalizeObjErrorJSError)(errorCatch);
    (0, _gerenciatdAdabyronUtils.sendLoadedService)(_gerenciatdAdabyronUtils.processName, myEvent, _gerenciatdAdabyronUtils.finishStates.FINISHED_KO_JS, objError);
    return null;
  }
};

exports.getPhoneFusion = getPhoneFusion;

var getConsultaParqueError = function getConsultaParqueError(infoError) {
  var sonda = infoError.sonda,
      _infoError$req6 = infoError.req,
      req = _infoError$req6 === void 0 ? {} : _infoError$req6,
      errorData = infoError.errorData;
  var newReq = {};
  var newResponse = req.response;

  if (typeof req.response === 'string') {
    newResponse = JSON.parse(req.response);
  }

  if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
    newResponse = req.response;
  }

  newReq.status = newResponse.codError + ' - ' + newResponse.tipoError;
  newReq.statusText = newResponse.descError;
  var objError = (0, _gerenciatdAdabyronUtils2.normalizeObjError)(newReq);
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.ERROR, objError); // si el normalizador no consigue meter un response

  if (objError && !objError.response) {
    objError.response = {
      error: errorData || true
    };
  }

  return objError;
};

var getConsultaParqueSuccess = function getConsultaParqueSuccess(infoSuccess) {
  var sonda = infoSuccess.sonda,
      responseObj = infoSuccess.responseObj;
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.OK);
  return responseObj;
};

var consultaParque = function consultaParque(data) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var idFront = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'webM';
  var idRequest = (0, _legadoApi.getUUID)(idFront);
  var sonda = new _gerenciatdUtils["default"]('CLIENT.CONSULTA_PARQUE', _gerenciatdAdabyronUtils.processName, context, idRequest);

  try {
    var URL_API = "".concat(_legadoApi.API.CLIENT.CONSULTA_PARQUE, "?").concat(idRequest);
    var input = {
      codFrontal: idFront,
      numComercial: data.numComercial,
      flagActualizar: false,
      flagOfertabilidad: true,
      modulo: data.modulo,
      datosUsuarioEntrada: {
        idTipDoc: data.idTipDoc,
        idNumdoc: data.idNumdoc
      }
    };

    if (NODE_ENV && NODE_ENV !== 'test') {
      if (sessionStorage && sessionStorage.getItem('firma') === 'si' && (sessionStorage.getItem('devEnvironment') === 'CERTI' || sessionStorage.getItem('devEnvironment') === 'CERTI_PRE')) {
        input = castCertiEntry(input);
        input.datosUsuarioEntrada.idTipDoc = data.idTipDoc;
        input.datosUsuarioEntrada.idNumdoc = data.idNumdoc;
      }

      if (typeof MOCK_ALLOWED !== 'undefined' && MOCK_ALLOWED) {
        if (sessionStorage && sessionStorage.getItem('consultaParque') === 'mock') {
          URL_API = _legadoApi.API.CLIENT.CONSULTA_PARQUE_MOCK;
        } else if (sessionStorage && sessionStorage.getItem('firma') === 'si') {
          URL_API = _legadoApi.API.CLIENT.CONSULTA_PARQUE_FIRMA;
        }
      }
    }

    return new Promise(function (resolve, reject) {
      var req = new XMLHttpRequest();
      sonda.startWS();
      req.open('POST', URL_API);

      req.onload = function () {
        if (req.status === 200) {
          var responseObj = null;

          if (typeof req.response === 'string') {
            responseObj = JSON.parse(req.response);
          }

          if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
            responseObj = req.response;
          }

          if (responseObj.resultado === 1) {
            var objError = getConsultaParqueError({
              sonda: sonda,
              req: req
            });
            reject(objError);
          } else {
            var responseObjSuccess = getConsultaParqueSuccess({
              sonda: sonda,
              responseObj: responseObj
            });
            resolve(responseObjSuccess);
          }
        } else {
          var _objError11 = getConsultaParqueError({
            sonda: sonda,
            req: req
          });

          reject(_objError11);
        }
      };

      req.onerror = function () {
        var objError = getConsultaParqueError({
          sonda: sonda,
          req: req
        });
        reject(objError);
      }; // Make the request


      req.setRequestHeader('Accept', 'application/json');
      req.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      var data = 'ENTRADA=' + JSON.stringify(input);
      req.send(data);
    });
  } catch (errorCatch) {
    sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.JS_ERROR);
    return null;
  }
};

exports.consultaParque = consultaParque;

var consultarDatosNotarialesError = function consultarDatosNotarialesError(infoError) {
  var sonda = infoError.sonda,
      _infoError$req7 = infoError.req,
      req = _infoError$req7 === void 0 ? {} : _infoError$req7,
      errorData = infoError.errorData;
  var newReq = {};
  var newResponse = req.response;

  if (typeof req.response === 'string') {
    newResponse = JSON.parse(req.response);
  }

  if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
    newResponse = req.response;
  }

  newReq.status = newResponse.codError + ' - ' + newResponse.tipoError;
  newReq.statusText = newResponse.descError;
  var objError = (0, _gerenciatdAdabyronUtils2.normalizeObjError)(newReq);
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.ERROR, objError); // si el normalizador no consigue meter un response

  if (objError && !objError.response) {
    objError.response = {
      error: errorData || true
    };
  }

  return objError;
};

var consultarDatosNotarialesSuccess = function consultarDatosNotarialesSuccess(infoSuccess) {
  var sonda = infoSuccess.sonda,
      responseObj = infoSuccess.responseObj;
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.OK);
  return responseObj;
};

var consultarDatosNotariales = function consultarDatosNotariales(data) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var idFront = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'webM';
  var idRequest = (0, _legadoApi.getUUID)(idFront);
  var sonda = new _gerenciatdUtils["default"]('CLIENT.CONSULTAR_DATOS_NOTARIALES', _gerenciatdAdabyronUtils.processName, context, idRequest);

  try {
    var URL_API = "".concat(_legadoApi.API.CLIENT.CONSULTAR_DATOS_NOTARIALES, "?").concat(idRequest);
    var input = {
      codFrontal: idFront,
      cuc: data.cuc
    };

    if (NODE_ENV && NODE_ENV !== 'test') {
      if (typeof MOCK_ALLOWED !== 'undefined' && MOCK_ALLOWED) {
        if (sessionStorage && sessionStorage.getItem('consultarDatosNotariales') === 'mock') {
          URL_API = _legadoApi.API.CLIENT.CONSULTAR_DATOS_NOTARIALES_MOCK;
        } else if (sessionStorage && sessionStorage.getItem('firma') === 'si') {
          URL_API = _legadoApi.API.CLIENT.CONSULTAR_DATOS_NOTARIALES_FIRMA;
          console.log('URL_API_FIRMA', URL_API);
        }
      }

      if (sessionStorage && sessionStorage.getItem('firma') === 'si' && (sessionStorage.getItem('devEnvironment') === 'CERTI' || sessionStorage.getItem('devEnvironment') === 'CERTI_PRE')) {
        URL_API = _legadoApi.API.CLIENT.CONSULTAR_DATOS_NOTARIALES_FIRMA;
        input = castCertiEntry(input);
      }
    }

    return new Promise(function (resolve, reject) {
      var req = new XMLHttpRequest();
      sonda.startWS();
      req.open('POST', URL_API);

      req.onload = function () {
        if (req.status === 200) {
          var responseObj = null;

          if (typeof req.response === 'string') {
            responseObj = JSON.parse(req.response);
          }

          if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
            responseObj = req.response;
          }

          if (responseObj.resultado === 1) {
            var objError = consultarDatosNotarialesError({
              sonda: sonda,
              req: req
            });
            reject(objError);
          } else {
            var responseObjSuccess = consultarDatosNotarialesSuccess({
              sonda: sonda,
              responseObj: responseObj
            });
            resolve(responseObjSuccess);
          }
        } else {
          var _objError12 = consultarDatosNotarialesError({
            sonda: sonda,
            req: req
          });

          reject(_objError12);
        }
      };

      req.onerror = function () {
        var objError = consultarDatosNotarialesError({
          sonda: sonda,
          req: req
        });
        reject(objError);
      }; // Make the request


      req.setRequestHeader('Accept', 'application/json');
      req.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      var data = 'ENTRADA=' + JSON.stringify(input);
      req.send(data);
    });
  } catch (errorCatch) {
    sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.JS_ERROR);
    console.log('ErrorCatch', errorCatch);
    return null;
  }
};

exports.consultarDatosNotariales = consultarDatosNotariales;

var guardarDatosNotarialesError = function guardarDatosNotarialesError(infoError) {
  var sonda = infoError.sonda,
      _infoError$req8 = infoError.req,
      req = _infoError$req8 === void 0 ? {} : _infoError$req8,
      errorData = infoError.errorData;
  var newReq = {};
  var newResponse = req.response;

  if (typeof req.response === 'string') {
    newResponse = JSON.parse(req.response);
  }

  if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
    newResponse = req.response;
  }

  newReq.status = newResponse.codError + ' - ' + newResponse.tipoError;
  newReq.statusText = newResponse.descError;
  var objError = (0, _gerenciatdAdabyronUtils2.normalizeObjError)(newReq);
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.ERROR, objError); // si el normalizador no consigue meter un response

  if (objError && !objError.response) {
    objError.response = {
      error: errorData || true
    };
  }

  return objError;
};

var guardarDatosNotarialesSuccess = function guardarDatosNotarialesSuccess(infoSuccess) {
  var sonda = infoSuccess.sonda,
      responseObj = infoSuccess.responseObj;
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.OK);
  return responseObj;
};

var guardarDatosNotariales = function guardarDatosNotariales(data) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var idFront = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'webM';
  var idRequest = (0, _legadoApi.getUUID)(idFront);
  var sonda = new _gerenciatdUtils["default"]('CLIENT.GUARDAR_DATOS_NOTARIALES', _gerenciatdAdabyronUtils.processName, context, idRequest);

  try {
    var URL_API = "".concat(_legadoApi.API.CLIENT.GUARDAR_DATOS_NOTARIALES, "?").concat(idRequest);
    var input = {
      codFrontal: idFront,
      datosNotariales: {
        cuc: data.cuc,
        nombreRepresentante: data.nombreRepresentante,
        tipDocRepresentante: data.tipDocRepresentante,
        numDocRepresentante: data.numDocRepresentante,
        notario: data.notario,
        protocolo: data.protocolo,
        fechaConstitucion: data.fechaConstitucion
      }
    };

    if (NODE_ENV && NODE_ENV !== 'test') {
      if (sessionStorage && sessionStorage.getItem('firma') === 'si' && (sessionStorage.getItem('devEnvironment') === 'CERTI' || sessionStorage.getItem('devEnvironment') === 'CERTI_PRE')) {
        input = castCertiEntry(input);
      }

      if (typeof MOCK_ALLOWED !== 'undefined' && MOCK_ALLOWED) {
        if (sessionStorage && sessionStorage.getItem('guardarDatosNotariales') === 'mock') {
          URL_API = _legadoApi.API.CLIENT.GUARDAR_DATOS_NOTARIALES_MOCK;
        } else if (sessionStorage && sessionStorage.getItem('firma') === 'si') {
          URL_API = _legadoApi.API.CLIENT.GUARDAR_DATOS_NOTARIALES_FIRMA;
        }
      }
    }

    return new Promise(function (resolve, reject) {
      var req = new XMLHttpRequest();
      sonda.startWS();
      req.open('POST', URL_API);

      req.onload = function () {
        if (req.status === 200) {
          var responseObj = null;

          if (typeof req.response === 'string') {
            responseObj = JSON.parse(req.response);
          }

          if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
            responseObj = req.response;
          }

          if (responseObj.resultado === 1) {
            var objError = guardarDatosNotarialesError({
              sonda: sonda,
              req: req
            });
            reject(objError);
          } else {
            var responseObjSuccess = guardarDatosNotarialesSuccess({
              sonda: sonda,
              responseObj: responseObj
            });
            resolve(responseObjSuccess);
          }
        } else {
          var _objError13 = guardarDatosNotarialesError({
            sonda: sonda,
            req: req
          });

          reject(_objError13);
        }
      };

      req.onerror = function () {
        var objError = guardarDatosNotarialesError({
          sonda: sonda,
          req: req
        });
        reject(objError);
      }; // Make the request


      req.setRequestHeader('Accept', 'application/json');
      req.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      var data = 'ENTRADA=' + JSON.stringify(input);
      req.send(data);
    });
  } catch (errorCatch) {
    sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.JS_ERROR);
    return null;
  }
};

exports.guardarDatosNotariales = guardarDatosNotariales;

var autenticarSealSignError = function autenticarSealSignError(infoError) {
  var sonda = infoError.sonda,
      _infoError$req9 = infoError.req,
      req = _infoError$req9 === void 0 ? {} : _infoError$req9,
      errorData = infoError.errorData;
  var newReq = {};
  var newResponse = req.response;

  if (typeof req.response === 'string') {
    newResponse = JSON.parse(req.response);
  }

  if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
    newResponse = req.response;
  }

  newReq.status = newResponse.codError + ' - ' + newResponse.tipoError;
  newReq.statusText = newResponse.descError;
  var objError = (0, _gerenciatdAdabyronUtils2.normalizeObjError)(newReq);
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.ERROR, objError); // si el normalizador no consigue meter un response

  if (objError && !objError.response) {
    objError.response = {
      error: errorData || true
    };
  }

  return objError;
};

var autenticarSealSignSuccess = function autenticarSealSignSuccess(infoSuccess) {
  var sonda = infoSuccess.sonda,
      responseObj = infoSuccess.responseObj;
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.OK);
  return responseObj;
};

var autenticarSealSign = function autenticarSealSign(data) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var idFront = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'webM';
  var idRequest = (0, _legadoApi.getUUID)(idFront);
  var sonda = new _gerenciatdUtils["default"]('CLIENT.AUTENTICAR_SEAL_SIGN', _gerenciatdAdabyronUtils.processName, context, idRequest);

  try {
    var URL_API = "".concat(_legadoApi.API.CLIENT.AUTENTICAR_SEAL_SIGN, "?").concat(idRequest);
    var input = {
      codFrontal: idFront
    };

    if (NODE_ENV && NODE_ENV !== 'test') {
      if (sessionStorage && sessionStorage.getItem('firma') === 'si' && (sessionStorage.getItem('devEnvironment') === 'CERTI' || sessionStorage.getItem('devEnvironment') === 'CERTI_PRE')) {
        input = castCertiEntry(input);
      }

      if (typeof MOCK_ALLOWED !== 'undefined' && MOCK_ALLOWED) {
        if (sessionStorage && sessionStorage.getItem('autenticarSealSign') === 'mock') {
          URL_API = _legadoApi.API.CLIENT.AUTENTICAR_SEAL_SIGN_MOCK;
        } else if (sessionStorage && sessionStorage.getItem('firma') === 'si') {
          URL_API = _legadoApi.API.CLIENT.AUTENTICAR_SEAL_SIGN_FIRMA;
        }
      }
    }

    return new Promise(function (resolve, reject) {
      var req = new XMLHttpRequest();
      sonda.startWS();
      req.open('POST', URL_API);

      req.onload = function () {
        if (req.status === 200) {
          var responseObj = null;

          if (typeof req.response === 'string') {
            responseObj = JSON.parse(req.response);
          }

          if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
            responseObj = req.response;
          }

          if (responseObj.resultado === 1) {
            var objError = autenticarSealSignError({
              sonda: sonda,
              req: req
            });
            reject(objError);
          } else {
            var responseObjSuccess = autenticarSealSignSuccess({
              sonda: sonda,
              responseObj: responseObj
            });
            resolve(responseObjSuccess);
          }
        } else {
          var _objError14 = autenticarSealSignError({
            sonda: sonda,
            req: req
          });

          reject(_objError14);
        }
      };

      req.onerror = function () {
        var objError = autenticarSealSignError({
          sonda: sonda,
          req: req
        });
        reject(objError);
      }; // Make the request


      req.setRequestHeader('Accept', 'application/json');
      req.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      var data = 'ENTRADA=' + JSON.stringify(input);
      req.send(data);
    });
  } catch (errorCatch) {
    sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.JS_ERROR);
    return null;
  }
};

exports.autenticarSealSign = autenticarSealSign;

var iniciarFirmaError = function iniciarFirmaError(infoError) {
  var sonda = infoError.sonda,
      _infoError$req10 = infoError.req,
      req = _infoError$req10 === void 0 ? {} : _infoError$req10,
      errorData = infoError.errorData;
  var newReq = {};
  var newResponse = req.response;

  if (typeof req.response === 'string') {
    newResponse = JSON.parse(req.response);
  }

  if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
    newResponse = req.response;
  }

  newReq.status = newResponse.codError + ' - ' + newResponse.tipoError;
  newReq.statusText = newResponse.descError;
  var objError = (0, _gerenciatdAdabyronUtils2.normalizeObjError)(newReq);
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.ERROR, objError); // si el normalizador no consigue meter un response

  if (objError && !objError.response) {
    objError.response = {
      error: errorData || true
    };
  }

  return objError;
};

var iniciarFirmaSuccess = function iniciarFirmaSuccess(infoSuccess) {
  var sonda = infoSuccess.sonda,
      responseObj = infoSuccess.responseObj;
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.OK);
  return responseObj;
};

var iniciarFirma = function iniciarFirma(data) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var idFront = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'webM';
  var idRequest = (0, _legadoApi.getUUID)(idFront);
  var sonda = new _gerenciatdUtils["default"]('CLIENT.INICIAR_FIRMA', _gerenciatdAdabyronUtils.processName, context, idRequest);

  try {
    var URL_API = "".concat(_legadoApi.API.CLIENT.INICIAR_FIRMA, "?").concat(idRequest);
    var input = {
      codFrontal: idFront,
      tokenSealSign: data.tokenSealSign,
      email: data.email,
      numOfertaCOLXPadre: data.numOfertaCOLXPadre,
      datosNavegador: data.datosNavegador
    };

    if (NODE_ENV && NODE_ENV !== 'test') {
      if (sessionStorage && sessionStorage.getItem('firma') === 'si' && (sessionStorage.getItem('devEnvironment') === 'CERTI' || sessionStorage.getItem('devEnvironment') === 'CERTI_PRE')) {
        input = castCertiEntry(input);
      }

      if (typeof MOCK_ALLOWED !== 'undefined' && MOCK_ALLOWED) {
        if (sessionStorage && sessionStorage.getItem('iniciarFirma') === 'mock') {
          URL_API = _legadoApi.API.CLIENT.INICIAR_FIRMA_MOCK;
        } else if (sessionStorage && sessionStorage.getItem('firma') === 'si') {
          URL_API = _legadoApi.API.CLIENT.INICIAR_FIRMA_FIRMA;
        }
      }
    }

    return new Promise(function (resolve, reject) {
      var req = new XMLHttpRequest();
      sonda.startWS();
      req.open('POST', URL_API);

      req.onload = function () {
        if (req.status === 200) {
          var responseObj = null;

          if (typeof req.response === 'string') {
            responseObj = JSON.parse(req.response);
          }

          if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
            responseObj = req.response;
          }

          if (responseObj.resultado === 1) {
            var objError = iniciarFirmaError({
              sonda: sonda,
              req: req
            });
            reject(objError);
          } else {
            var responseObjSuccess = iniciarFirmaSuccess({
              sonda: sonda,
              responseObj: responseObj
            });
            resolve(responseObjSuccess);
          }
        } else {
          var _objError15 = iniciarFirmaError({
            sonda: sonda,
            req: req
          });

          reject(_objError15);
        }
      };

      req.onerror = function () {
        var objError = iniciarFirmaError({
          sonda: sonda,
          req: req
        });
        reject(objError);
      }; // Make the request


      req.setRequestHeader('Accept', 'application/json');
      req.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      var data = 'ENTRADA=' + JSON.stringify(input);
      req.send(data);
    });
  } catch (errorCatch) {
    sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.JS_ERROR);
    return null;
  }
};

exports.iniciarFirma = iniciarFirma;

var finalizarFirmaError = function finalizarFirmaError(infoError) {
  var sonda = infoError.sonda,
      _infoError$req11 = infoError.req,
      req = _infoError$req11 === void 0 ? {} : _infoError$req11,
      errorData = infoError.errorData;
  var newReq = {};
  var newResponse = req.response;

  if (typeof req.response === 'string') {
    newResponse = JSON.parse(req.response);
  }

  if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
    newResponse = req.response;
  }

  newReq.status = newResponse.codError + ' - ' + newResponse.tipoError;
  newReq.statusText = newResponse.descError;
  var objError = (0, _gerenciatdAdabyronUtils2.normalizeObjError)(newReq);
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.ERROR, objError); // si el normalizador no consigue meter un response

  if (objError && !objError.response) {
    objError.response = {
      error: errorData || true
    };
  }

  return objError;
};

var finalizarFirmaSuccess = function finalizarFirmaSuccess(infoSuccess) {
  var sonda = infoSuccess.sonda,
      responseObj = infoSuccess.responseObj;
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.OK);
  return responseObj;
};

var finalizarFirma = function finalizarFirma(data) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var idFront = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'webM';
  var idRequest = (0, _legadoApi.getUUID)(idFront);
  var sonda = new _gerenciatdUtils["default"]('CLIENT.FINALIZAR_FIRMA', _gerenciatdAdabyronUtils.processName, context, idRequest);

  try {
    var URL_API = "".concat(_legadoApi.API.CLIENT.FINALIZAR_FIRMA, "?").concat(idRequest);
    var input = {
      codFrontal: idFront,
      tokenSealSign: data.tokenSealSign,
      codigoOTP: data.codigoOTP,
      instanciaDocumentoFirma: data.instanciaDocumentoFirma
    };

    if (NODE_ENV && NODE_ENV !== 'test') {
      if (sessionStorage && sessionStorage.getItem('firma') === 'si' && (sessionStorage.getItem('devEnvironment') === 'CERTI' || sessionStorage.getItem('devEnvironment') === 'CERTI_PRE')) {
        input = castCertiEntry(input);
      }

      if (typeof MOCK_ALLOWED !== 'undefined' && MOCK_ALLOWED) {
        if (sessionStorage && sessionStorage.getItem('iniciarFirma') === 'mock') {
          URL_API = _legadoApi.API.CLIENT.FINALIZAR_FIRMA_MOCK;
        } else if (sessionStorage && sessionStorage.getItem('firma') === 'si') {
          URL_API = _legadoApi.API.CLIENT.FINALIZAR_FIRMA_FIRMA;
        }
      }
    }

    return new Promise(function (resolve, reject) {
      var req = new XMLHttpRequest();
      sonda.startWS();
      req.open('POST', URL_API);

      req.onload = function () {
        if (req.status === 200) {
          var responseObj = null;

          if (typeof req.response === 'string') {
            responseObj = JSON.parse(req.response);
          }

          if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
            responseObj = req.response;
          }

          if (responseObj.resultado === 1) {
            var objError = finalizarFirmaError({
              sonda: sonda,
              req: req
            });
            reject(objError);
          } else {
            var responseObjSuccess = finalizarFirmaSuccess({
              sonda: sonda,
              responseObj: responseObj
            });
            resolve(responseObjSuccess);
          }
        } else {
          var _objError16 = finalizarFirmaError({
            sonda: sonda,
            req: req
          });

          reject(_objError16);
        }
      };

      req.onerror = function () {
        var objError = finalizarFirmaError({
          sonda: sonda,
          req: req
        });
        reject(objError);
      }; // Make the request


      req.setRequestHeader('Accept', 'application/json');
      req.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      var data = 'ENTRADA=' + JSON.stringify(input);
      req.send(data);
    });
  } catch (errorCatch) {
    sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.JS_ERROR);
    return null;
  }
};

exports.finalizarFirma = finalizarFirma;

var consultaOfertaMError = function consultaOfertaMError(infoError) {
  var sonda = infoError.sonda,
      _infoError$req12 = infoError.req,
      req = _infoError$req12 === void 0 ? {} : _infoError$req12,
      errorData = infoError.errorData;
  var newReq = {};
  var newResponse = req.response;

  if (typeof req.response === 'string') {
    newResponse = JSON.parse(req.response);
  }

  if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
    newResponse = req.response;
  }

  newReq.status = newResponse.codError + ' - ' + newResponse.tipoError;
  newReq.statusText = newResponse.descError;
  var objError = (0, _gerenciatdAdabyronUtils2.normalizeObjError)(newReq);
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.ERROR, objError); // si el normalizador no consigue meter un response

  if (objError && !objError.response) {
    objError.response = {
      error: errorData || true
    };
  }

  return objError;
};

var consultaOfertaMSuccess = function consultaOfertaMSuccess(infoSuccess) {
  var sonda = infoSuccess.sonda,
      responseObj = infoSuccess.responseObj;
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.OK);
  return responseObj;
};

var consultaOfertaM = function consultaOfertaM(data) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var idFront = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'webM';
  var idRequest = (0, _legadoApi.getUUID)(idFront);
  var sonda = new _gerenciatdUtils["default"]('CLIENT.CONSULTA_OFERTA_M', _gerenciatdAdabyronUtils.processName, context, idRequest);

  try {
    var URL_API = "".concat(_legadoApi.API.CLIENT.CONSULTA_OFERTA_M, "?").concat(idRequest);
    var input = {
      codFrontal: idFront,
      idNavegacion: data.idNavegacion,
      datosCliente: {
        tipDoc: data.tipDoc,
        numDoc: data.numDoc,
        nombre: data.nombre,
        apellido1: data.apellido1,
        apellido2: data.apellido2,
        razonSocial: data.razonSocial,
        emailContacto: data.emailContacto,
        movilContacto: data.movilContacto,
        tipoTitular: data.tipoTitular
      },
      idNavOferta: data.idNavOferta,
      planesDestino: {
        codPlanFact: data.codPlanFact,
        codPlanTari: data.codPlanTari
      }
    };

    if (data.tipoOperacion === 'SIM') {
      input.numIcc = data.numIcc;
    } else if (data.tipoOperacion === 'REPO') {
      input.numTelefono = data.numTelefono;
      input.planesOrigen = {
        codPlanFact: data.codPlanFact,
        codPlanTari: data.codPlanTari
      };
    }

    if (NODE_ENV && NODE_ENV !== 'test') {
      if (sessionStorage && sessionStorage.getItem('firma') === 'si' && (sessionStorage.getItem('devEnvironment') === 'CERTI' || sessionStorage.getItem('devEnvironment') === 'CERTI_PRE')) {
        input = castCertiEntry(input);
      }

      if (typeof MOCK_ALLOWED !== 'undefined' && MOCK_ALLOWED) {
        if (sessionStorage && sessionStorage.getItem('consultaOfertaM') === 'mock') {
          URL_API = _legadoApi.API.CLIENT.CONSULTA_OFERTA_M_MOCK;
        } else if (sessionStorage && sessionStorage.getItem('firma') === 'si') {
          URL_API = _legadoApi.API.CLIENT.CONSULTA_OFERTA_M_FIRMA;
        }
      }
    }

    return new Promise(function (resolve, reject) {
      var req = new XMLHttpRequest();
      sonda.startWS();
      req.open('POST', URL_API);

      req.onload = function () {
        if (req.status === 200) {
          var responseObj = null;

          if (typeof req.response === 'string') {
            responseObj = JSON.parse(req.response);
          }

          if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
            responseObj = req.response;
          }

          if (responseObj.resultado === 0) {
            var responseObjSuccess = consultaOfertaMSuccess({
              sonda: sonda,
              responseObj: responseObj
            });
            resolve(responseObjSuccess);
          } else {
            var objError = consultaOfertaMError({
              sonda: sonda,
              req: req
            });
            reject(objError);
          }
        } else {
          var _objError17 = consultaOfertaMError({
            sonda: sonda,
            req: req
          });

          reject(_objError17);
        }
      };

      req.onerror = function () {
        var objError = consultaOfertaMError({
          sonda: sonda,
          req: req
        });
        reject(objError);
      }; // Make the request


      req.setRequestHeader('Accept', 'application/json');
      req.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      var data = 'ENTRADA=' + JSON.stringify(input);
      req.send(data);
    });
  } catch (errorCatch) {
    sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.JS_ERROR);
    return null;
  }
};

exports.consultaOfertaM = consultaOfertaM;

//# sourceMappingURL=index.js.map